import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  FolderOpen, 
  AlertTriangle, 
  TrendingUp, 
  Newspaper,
  MonitorSpeaker,
  X
} from 'lucide-react';

const Sidebar = ({ isOpen, setIsOpen }) => {
  const location = useLocation();

  const menuItems = [
    {
      name: 'Dashboard',
      path: '/dashboard',
      icon: LayoutDashboard
    },
    {
      name: 'News Categories',
      path: '/news-categories',
      icon: FolderOpen
    },
    { 
      name: 'Breaking News',
      path: '/breaking-news',
      icon: AlertTriangle
    },
    {
      name: 'Trending News',
      path: '/trending-news',
      icon: TrendingUp
    },
    {
      name: 'General News',
      path: '/news',
      icon: Newspaper
    },
    {
      name: 'Advertisements',
      path: '/advertisements',
      icon: MonitorSpeaker
    }
  ];

  return (
    <>
      <div className={`
        fixed inset-y-0 left-0 z-30 w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out
        lg:translate-x-0 lg:static lg:inset-0
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
      `}>
        <div className="flex items-center justify-between h-16 px-6 border-b border-gray-200">
          <h2 className="text-xl font-bold text-gray-800">VicharMedia24</h2>
          <button
            onClick={() => setIsOpen(false)}
            className="lg:hidden p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        
        <nav className="mt-8">
          <div className="px-4 space-y-2">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsOpen(false)}
                  className={`
                    flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors duration-200
                    ${isActive 
                      ? 'sidebar-active' 
                      : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                    }
                  `}
                >
                  <Icon className="mr-3 h-5 w-5" />
                  {item.name}
                </Link>
              );
            })}
          </div>
        </nav>
      </div>
    </>
  );
};

export default Sidebar;
















// import React from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import { 
//   LayoutDashboard, 
//   FolderOpen, 
//   AlertTriangle, 
//   TrendingUp, 
//   Newspaper,
//   X
// } from 'lucide-react';

// const Sidebar = ({ isOpen, setIsOpen }) => {
//   const location = useLocation();

//   const menuItems = [
//     {
//       name: 'Dashboard',
//       path: '/dashboard',
//       icon: LayoutDashboard
//     },
//     {
//       name: 'News Categories',
//       path: '/news-categories',
//       icon: FolderOpen
//     },
//     {
//       name: 'Breaking News',
//       path: '/breaking-news',
//       icon: AlertTriangle
//     },
//     {
//       name: 'Trending News',
//       path: '/trending-news',
//       icon: TrendingUp
//     },
//     {
//       name: 'General News',
//       path: '/news',
//       icon: Newspaper
//     }
//   ];

//   return (
//     <>
//       <div className={`
//         fixed inset-y-0 left-0 z-30 w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out
//         lg:translate-x-0 lg:static lg:inset-0
//         ${isOpen ? 'translate-x-0' : '-translate-x-full'}
//       `}>
//         <div className="flex items-center justify-between h-16 px-6 border-b border-gray-200">
//           <h2 className="text-xl font-bold text-gray-800">VicharMedia24</h2>
//           <button
//             onClick={() => setIsOpen(false)}
//             className="lg:hidden p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100"
//           >
//             <X className="h-5 w-5" />
//           </button>
//         </div>
        
//         <nav className="mt-8">
//           <div className="px-4 space-y-2">
//             {menuItems.map((item) => {
//               const Icon = item.icon;
//               const isActive = location.pathname === item.path;
              
//               return (
//                 <Link
//                   key={item.path}
//                   to={item.path}
//                   onClick={() => setIsOpen(false)}
//                   className={`
//                     flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors duration-200
//                     ${isActive 
//                       ? 'sidebar-active' 
//                       : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
//                     }
//                   `}
//                 >
//                   <Icon className="mr-3 h-5 w-5" />
//                   {item.name}
//                 </Link>
//               );
//             })}
//           </div>
//         </nav>
//       </div>
//     </>
//   );
// };

// export default Sidebar;